import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import AboutSection from "../components/AboutSection";
import BlogSection from "../components/BlogSection";
import BookingSection from "../components/BookingSection";
import ClientSection from "../components/ClientSection";
import CTASection from "../components/CTASection";
import GiftCardsSection from "../components/GiftCardsSection";
import HeroSection from "../components/Hero";
import Layout from "../components/Layout";
import PlansSection from "../components/PlansSection";
import Seo from "../components/SEO";
import ServicesSection from "../components/ServicesSection";
import Testimonial from "../components/Testimonial";
import PopUp from "../components/PopUp";
import { useState, useEffect } from "react";

const META_DATA = {
  title: "Wellness & Recovery Studio | Washington DC | HighKey Balance", 
  description: `Recover, relax and recharge at Washington D.C.'s premier all-in-one wellness and recovery studio, plus whole body cryotherapy center. Call or book today!`,
  content: "bsji1ONruYws6Asi7wtTb7hN4QzBJWDGO64lV-D4_AM",
};

const Home = () => {
  const { allSanityServices } = useStaticQuery(graphql`
    query GetServicesCardSectionData {
      allSanityServices {
        nodes {
          title
          slug {
            current
          }
          cardDescription
          featuredImageMobile {
            asset {
              url
              gatsbyImageData
            }
          }
        }
      }
    }
  `);

  const services = allSanityServices.nodes;

  const [toggle, setToggle] = useState();

  const toggleFunc = (flag) => {
    setToggle(flag);
  };

  useEffect(() => {
    (function (s, e, n, d, er) {
      s['Sender'] = er;
      s[er] = s[er] || function () {
        (s[er].q = s[er].q || []).push(arguments)
      }, s[er].l = 1 * new Date();
      var a = e.createElement(n),
          m = e.getElementsByTagName(n)[0];
      a.async = 1;
      a.src = d;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://cdn.sender.net/accounts_resources/universal.js', 'sender');
    window.sender('7aa3f02f191232');
  }, []);

  return (
    <>
      <Layout>
        <Seo {...META_DATA} />
        <HeroSection />
        <CTASection />
        <ClientSection />
        <AboutSection />
        <ServicesSection services={services} />
        <Testimonial />
        <PlansSection toggleFunc={toggleFunc}/>
        <GiftCardsSection />
        <BlogSection />
        <BookingSection />
      </Layout>
    </>
  );
};

export default Home;
